const riot = require('riot');

riot.tag2('module-bg-image', '<div class="absolute trbl0"> <div class="absolute trbl0 s-full bg-main"></div> </div>', '', '', function(opts) {
});